import * as React from 'react'

import { BasicForm } from '~/components/forms'

function PortableContactForm() {
  return <BasicForm />
}

export { PortableContactForm }
